import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {useState} from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import Container from 'react-bootstrap/Container';
import './InstructionsModal.css'

const InstructionsModal = () => {
  const [show, setShow] = useState(false);

  return (
    <Container fluid className='infoParent'>
      <Button variant="primary" className='infoButton' onClick={() => setShow(true)}>
        <FaInfoCircle />
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-20w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Welcome!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Hover over a country and click to begin exploring.
          </p>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default InstructionsModal
